var map = {
	"./Pheal-Logo-Black-S.svg": "gSVs",
	"./Pheal-Logo-Black.svg": "yqG6",
	"./Pheal-Logo-White-S.svg": "Y+/F",
	"./Pheal-Logo-White.svg": "fv8x"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RFum";